export default "__VITE_ASSET__5a77d501__"